// parses source, id and other components from the URL
// throws error if url is invalid for this app

const sourceAbbrvs = {
  sc: 'showclix',
  pm: 'patronmanager',
  tl: 'ticketleap',
  mk: 'mock',
  gt: 'growtix',
};

export function parseURLComponents(url) {
  // Valid URLs
  // /player/<source>/<id>
  // /player/<source>/<id>/<access code>
  // /player/<source>/<id>/room/<room name>
  // /player/<source>/<id>/room/<room name>/<access code>
  // "player" = 0 / source = 1 / id = 2 / "room" = 3 / room = 4 / code = 5
  const path = document.location.pathname
    .split('/')
    .filter((x) => !!x)
    .map(decodeURIComponent);
  if (path[0] !== 'player') {
    throw Error('Expected URL to begin with /player.');
  }
  if (path.length < 3) {
    throw Error('URL is missing required components: source and id.');
  }
  if (path.length > 6) {
    throw Error('URL is invalid: too long');
  }
  if (path.length > 4 && path[3] !== 'room') {
    throw Error('URL is invalid: expecting room information');
  }
  let source = sourceAbbrvs[path[1]] || path[1],
    id = path[2],
    code = null,
    room = null;
  if (path.length === 4) {
    code = path[3];
  }
  if (path.length === 6) {
    room = path[4];
    code = path[5];
  }
  return { source, id, room, code };
}

export function linkify(text) {
  var urlRegex = /(\bhttps?:\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
  return text.replace(urlRegex, function(url) {
    return '<a target="_blank" href="' + url + '">' + url + '</a>';
  });
}
